import { TRevenda } from '../../../../services';
import { formataCep, formataCnpj, formataCpf, formataTelefone } from '../../../../utils';

type State = {
	razaoSocial: string;
	fantasia: string;
	tipoDocumento: string;
	numeroDocumento: string;
	inscricaoEstadual: string;
	inscricaoMunicipal: string;
	email: string;
	telefone: string;
	celular: string;
	cep: string;
	estado: string;
	cidade: string;
	bairro: string;
	logradouro: string;
	numeroLogradouro: string;
	complementoLogradouro: string;
	responsavel: string;
	indicacao: string | null;
	tagAtivo: string;
	tagDeferimento: string;
	observacao: string | null;
};

type Action =
	| { type: 'SET_VALUE'; field: string; payload: string }
	| { type: 'SET_SELECT_OPTION'; field: string; value: string | number }
	| { type: 'REPLACE_STATE'; payload: State };

export const newShopkeeperFormInitialState: State = {
	razaoSocial: '',
	fantasia: '',
	tipoDocumento: '',
	numeroDocumento: '',
	inscricaoEstadual: '',
	inscricaoMunicipal: '',
	email: '',
	telefone: '',
	celular: '',
	cep: '',
	estado: '',
	cidade: '',
	bairro: '',
	logradouro: '',
	numeroLogradouro: '',
	complementoLogradouro: '',
	indicacao: '',
	responsavel: '',
	tagAtivo: '',
	tagDeferimento: '',
	observacao: '',
};

export const newShopkeeperFormReducer = (state: State, action: Action) => {
	switch (action.type) {
		case 'SET_VALUE':
			const campo = action.field;
			let valor = '';

			switch (campo) {
				case 'telefone':
				case 'celular':
					valor = formataTelefone(action.payload);
					break;
				case 'cep':
					valor = formataCep(action.payload);
					break;
				case 'numeroDocumento':
					if (state.tipoDocumento === '1') {
						valor = formataCpf(action.payload);
					}

					if (state.tipoDocumento === '2') {
						valor = formataCnpj(action.payload);
					}

					break;
				default:
					valor = action.payload;
			}

			return {
				...state,
				[action.field]: valor,
			};
		case 'SET_SELECT_OPTION':
			return {
				...state,
				[action.field]: action.value,
			};
		case 'REPLACE_STATE':
			const documento = action.payload.numeroDocumento;
			let documentoFormatado = documento;

			if (state.tipoDocumento === '1') {
				documentoFormatado = formataCpf(action.payload.numeroDocumento);
			}

			if (state.tipoDocumento === '2') {
				documentoFormatado = formataCnpj(action.payload.numeroDocumento);
			}

			return {
				...action.payload,
				telefone: formataTelefone(action.payload.telefone),
				cep: formataCep(action.payload.cep),
				numeroDocumento: documentoFormatado,
			};
		default:
			return state;
	}
};

export const tranformShopkeeperResponseIntoForm = (shopkeeper: TRevenda): State => {
	const {
		razaoSocial,
		fantasia,
		tipoDocumento,
		numeroDocumento,
		email,
		telefone,
		celular,
		cep,
		estado,
		cidade,
		bairro,
		logradouro,
		numeroLogradouro,
		complementoLogradouro,
		inscricaoEstadual,
		inscricaoMunicipal,
		responsavel,
		tagAtivo,
		tagDeferimento,
		indicacao,
		observacao,
	} = shopkeeper;
	return {
		razaoSocial,
		fantasia,
		tipoDocumento,
		numeroDocumento,
		email,
		inscricaoEstadual,
		inscricaoMunicipal,
		telefone,
		celular,
		cep,
		estado,
		cidade,
		bairro,
		logradouro,
		numeroLogradouro,
		complementoLogradouro,
		tagAtivo,
		tagDeferimento,
		observacao,
		indicacao,
		responsavel,
	};
};

export const transformStateIntoShopkeeperRequest = (form: State): Partial<TRevenda> => {
	return {
		razaoSocial: form.razaoSocial,
		fantasia: form.fantasia,
		tipoDocumento: form.tipoDocumento,
		numeroDocumento: form.numeroDocumento,
		email: form.email,
		inscricaoEstadual: form.inscricaoEstadual,
		inscricaoMunicipal: form.inscricaoMunicipal,
		telefone: form.telefone,
		celular: form.celular,
		cep: form.cep,
		estado: form.estado,
		cidade: form.cidade,
		bairro: form.bairro,
		logradouro: form.logradouro,
		numeroLogradouro: form.numeroLogradouro,
		complementoLogradouro: form.complementoLogradouro,
		tagAtivo: form.tagAtivo,
		tagDeferimento: form.tagDeferimento,
		observacao: form.observacao,
		indicacao: form.indicacao,
		responsavel: form.responsavel,
	};
};
